(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-baja', {
            parent: 'entity',
            url: '/ss-baja',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSBajas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-baja/s-s-bajas.html',
                    controller: 'SSBajaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-baja-detail', {
            parent: 'ss-baja',
            url: '/ss-baja/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSBaja'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-baja/ss-baja-detail.html',
                    controller: 'SSBajaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSBaja', function($stateParams, SSBaja) {
                    return SSBaja.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-baja',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-baja-detail.edit', {
            parent: 'ss-baja-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-dialog.html',
                    controller: 'SSBajaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSBaja', function(SSBaja) {
                            return SSBaja.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-baja.new', {
            parent: 'ss-baja',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-dialog.html',
                    controller: 'SSBajaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaBaja: null,
                                tipoBaja: null,
                                motivo: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-baja', null, { reload: 'ss-baja' });
                }, function() {
                    $state.go('ss-baja');
                });
            }]
        })
        .state('ss-baja.edit', {
            parent: 'ss-baja',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-dialog.html',
                    controller: 'SSBajaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSBaja', function(SSBaja) {
                            return SSBaja.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-baja', null, { reload: 'ss-baja' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-baja.delete', {
            parent: 'ss-baja',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-baja/ss-baja-delete-dialog.html',
                    controller: 'SSBajaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSBaja', function(SSBaja) {
                            return SSBaja.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-baja', null, { reload: 'ss-baja' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
